import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {editorialInsights_template} from "../components/templates/editorialInsights_template";

declare var ko: any;
declare var page: any;

export class editorialInsights extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected editorialInsights_template: editorialInsights_template;

    protected getModuleName(){
        return "editorialInsights";
    }

    buildContent() : Array<Element>{

        this.editorialInsights_template = new editorialInsights_template( "editorialInsights", this.viewModel, this );
        this.template = this.editorialInsights_template;

        return [this.editorialInsights_template.build()];
    }

    public fillPage() : void{
        this.editorialInsights_template.initiateDimensionSelectTag();
        this.editorialInsights_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/editorial_insights/list_form_data';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    public getListData(): void{

        this.loadingIn(this.editorialInsights_template.builtTemplate.children.namedItem("list-results"));
        this.editorialInsights_template.hideExportButton();
        this.editorialInsights_template.validateOrderBy();

        let subViewModel = this.editorialInsights_template.getViewModelForRequest();
        let baseApiUrl = '/api/editorial_insights/list_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword): void{

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        if(id == 'primaryCategoriesFilter'){
            usrReq_url = '/api/emakiCategorySuggestions/';
        }

        if(id == 'srEditorsFilter'){
            usrReq_url = '/api/emakiUsers/get/';
        }

        if(id == 'jrEditorsFilter'){
            usrReq_url = '/api/emakiUsers/get/';
        }

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        if(id == 'primaryCategoriesFilter'){
            this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteCategoriesSuggestionsReturn;
        }

        if(id == 'srEditorsFilter'){
            this.XHRHdl.onReadyStateFunction = this.onGetAutoCompleteSrEditorsSuggestionsReturn;
        }

        if(id == 'jrEditorsFilter'){
            this.XHRHdl.onReadyStateFunction = this.onGetAutoCompleteJrEditorsSuggestionsReturn;
        }

        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteCategoriesSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.editorialInsights_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.editorialInsights_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.editorialInsights_template.deactivateLoading();
            });
        }
    }

    protected onGetAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.editorialInsights_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.editorialInsights_template.setSrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.editorialInsights_template.deactivateLoading();
            });
        }
    }

    protected onGetAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.editorialInsights_template.validationsList.clearMessages();

                if(responseParsed.data){

                    obj.editorialInsights_template.setJrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.editorialInsights_template.deactivateLoading();
            });
        }
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.editorialInsights_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.editorialInsights_template.builtTemplate);
            });
        }
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.editorialInsights_template.validationsList.clearMessages();
                obj.updateList(responseParsed.data);

                // LOADING : ends
                obj.loadingOut(obj.editorialInsights_template.builtTemplate.children.namedItem("list-results"));
            });
        };
    }

    protected updateFilters(responseParsed: any){

        this.editorialInsights_template.setBrandFilterItems(responseParsed.departments);
        this.editorialInsights_template.setBrandSegments(responseParsed.brandSegments);
        this.editorialInsights_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.editorialInsights_template.setPostPaymentCategorySystemFilterItems(responseParsed.postPaymentCategorySystems);
        this.editorialInsights_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.editorialInsights_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.editorialInsights_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.editorialInsights_template.setPostContentTypesGroupFilterItems();
        this.editorialInsights_template.setPublishStatusItems();
    }

    protected updateList(responseParsed: any) {

        for (let item of responseParsed.editorialInsightsDataPerDimensionGroupings) {
            item.Day = this.formatDate(item.Day + "T12:00:00");
        }

        this.editorialInsights_template.setEditorialInsightsData(responseParsed);
        this.editorialInsights_template.setInProgress(responseParsed.inProgress);
    }

    protected filterMultipleSelectorOnChange(){
        this.editorialInsights_template.resetDefaultDimensionFilters();
        this.editorialInsights_template.setSelectDimensionsObjects();
        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
    }

    protected filterSimpleOnChange(){
        this.getListData();
    }

    public listReorder(){
        this.getListData();
    }

    private formatDate(date) {
        let weekday = new Array(7);
        weekday[0] = "Sun";
        weekday[1] = "Mon";
        weekday[2] = "Tue";
        weekday[3] = "Wed";
        weekday[4] = "Thu";
        weekday[5] = "Fri";
        weekday[6] = "Sat";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }

}



// WEBPACK FOOTER //
// ./js/modules/editorialInsights.ts